<template lang="pug">
  md-whiteframe.reward(:class='frameClassName')
    md-checkbox(:value='check', @change='updateValue', md-theme='green').md-primary 交換可能数: {{ exchanged }}/{{ reward.max }}
    p.md-title {{ reward.name }}
    md-button.md-icon-button.md-raised.md-primary(@click='increment')
      md-icon add
    md-button.md-icon-button.md-raised.md-accent(@click='decrement')
      md-icon remove
    p 絵馬: {{ reward.ema }}
</template>

<script>
export default {
  props: ['index'],
  data () {
    return {
      check: this.$store.getters.getWant(this.index),
      reward: this.$store.getters.getReward(this.index),
      exchanged: this.$store.getters.getExchanged(this.index)
    }
  },
  computed: {
    frameClassName () {
      if (!this.check) return ['disabled']
      if (this.exchanged === this.reward.max) return ['completed']
      return []
    }
  },
  methods: {
    updateValue (value) {
      this.check = value
      this.$store.commit('updateWant', [this.index, value])
    },
    increment () {
      if (this.exchanged < this.reward.max) {
        this.exchanged++
        this.$store.commit('updateExchanged', [this.index, this.exchanged])
      }
    },
    decrement () {
      if (this.exchanged > 0) {
        this.exchanged--
        this.$store.commit('updateExchanged', [this.index, this.exchanged])
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .reward
    width: 15vw
  .disabled
    background-color: gray
  .completed
    background-color: lightgray
</style>




// WEBPACK FOOTER //
// src/components/Reward.vue